import { createAction } from '@reduxjs/toolkit';

import type { DownloadStateAction } from './types';

type DownloadStateActionData = DownloadStateAction['input']['data'];

export const downloading = createAction<DownloadStateActionData['downloading']>('download-area/in-download');
export const reportList = createAction<DownloadStateActionData['reportList']>('download-area/report-name');
